import { useCallback } from 'react';

import { useSecondaryPanelUI } from '@src/components/SecondaryPanel/context/SecondaryPanelContext';

/**
 * Empty mount node inside the secondary panel rail.
 * Use createPortal(..., railPortalHostEl) from a subtree that must keep providers
 * that are not ancestors of SecondaryPanel (e.g. route-level context).
 */
export const SecondaryPanelRailPortalHost = () => {
  const { setRailPortalHostEl } = useSecondaryPanelUI();

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      setRailPortalHostEl(prev => (prev === node ? prev : node));
    },
    [setRailPortalHostEl],
  );

  return (
    <div
      ref={ref}
      className="secondary-panel-rail-portal-host"
      data-testid="secondary-panel-rail-portal-host"
    />
  );
};
